const convertToCurrencyFormat = (value: string | number): string => {
  return `R$ ${Number(value).toFixed(2).replace('.', ',')}`;
};

export default convertToCurrencyFormat;
